import { NewsItem, NewsPriority } from "../interfaces/NewsItem";
import { isNewsViewed } from "./newsStorage";

const PRIORITY_ORDER: Record<NewsPriority, number> = {
  HIGH: 0,
  MEDIUM: 1,
  LOW: 2,
};

const normalizeTimestamp = (timestamp?: number) => {
  if (typeof timestamp !== "number") {
    return undefined;
  }

  return timestamp < 1_000_000_000_000 ? timestamp * 1000 : timestamp;
};

export const filterActiveNews = (newsItems: NewsItem[]): NewsItem[] => {
  const now = Date.now();

  return newsItems.filter((item) => {
    if (!item || !item.isActive) return false;

    const expiresAt = normalizeTimestamp(item.expiresAt);
    const isExpired = typeof expiresAt === "number" && expiresAt < now;

    if (isExpired) return false;
    if (!item.newsId) return false;
    if (isNewsViewed(item.newsId)) return false;

    return true;
  });
};

export const sortNewsByPriority = (newsItems: NewsItem[]): NewsItem[] => {
  return [...newsItems].sort((a, b) => {
    const priorityDifference =
      (PRIORITY_ORDER[a.priority] ?? Number.MAX_SAFE_INTEGER) -
      (PRIORITY_ORDER[b.priority] ?? Number.MAX_SAFE_INTEGER);

    if (priorityDifference !== 0) {
      return priorityDifference;
    }

    const createdAtA = normalizeTimestamp(a.createdAt) ?? 0;
    const createdAtB = normalizeTimestamp(b.createdAt) ?? 0;
    return createdAtB - createdAtA;
  });
};

export const formatNewsTimestamp = (timestamp: number): string => {
  const normalizedTimestamp = normalizeTimestamp(timestamp);
  if (!normalizedTimestamp) {
    return "";
  }

  const date = new Date(normalizedTimestamp);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return date.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
};
